import {connect} from 'react-redux';
import {DesignChapter} from '@learningblocks/storybook-components';

import {getIsModalOpen} from './StepViewComplete.selector';
import {setDesignTab, viewThreeComplete} from '@learningblocks/exp-redux';

function mapStateToProps(state, ownProps) {
  return {
    isOpen: getIsModalOpen(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onClickNext: (params) => {
      dispatch(setDesignTab(params));
      dispatch(viewThreeComplete());
    },
  };
}

export const StepViewComplete = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignChapter.StepViewComplete);
